// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SuggestedContentSidebar-cls1___acce31bbb917db6ffbe{/*!*/}.SuggestedContentSidebar-cls2__add38750685336fd2ed2{height:auto !important;color:#535366;font-size:12px}.SuggestedContentSidebar-cls2__add38750685336fd2ed2:not(:hover){text-decoration:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SuggestedContentSidebar-cls1___acce31bbb917db6ffbe",
	"cls2": "SuggestedContentSidebar-cls2__add38750685336fd2ed2 SuggestedContentSidebar-cls1___acce31bbb917db6ffbe"
};
export default ___CSS_LOADER_EXPORT___;
